import { withFormsy, propTypes } from "formsy-react";
import React from "react";
import { FormGroup, FormFeedback, Label, FormText } from "reactstrap";
import { Spinner } from "../../Shared";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import "./PhoneInput.scss";

export class PhoneInputComponent extends React.Component {
  state = {
    error: true
  };
  changeValue = (status, value, countryData, number, id) => {
    this.validatePhone(status);
    this.props.setValue(value);
    this.props.getCountryCode(countryData.dialCode);
  };

  validatePhone = status => {
    this.setState({
      error: status
    });
  };

  lookup = callback => {
    this.loadJSONP("http://ipinfo.io", "sendBack");
    window.sendBack = resp => {
      const countryCode = resp && resp.country ? resp.country : "";
      callback(countryCode);
    };
  };

  loadJSONP = (url, callback) => {
    const ref = window.document.getElementsByTagName("script")[0];
    const script = window.document.createElement("script");
    script.src = `${url +
      (url.indexOf("?") + 1 ? "&" : "?")}callback=${callback}`;
    ref.parentNode.insertBefore(script, ref);
    script.onload = () => {
      script.remove();
    };
  };

  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      className,
      showRequired,
      showError,
      getValue,
      showLoader,
      name,
      title,
      isPristine,
      infoText,
      hasValue,
      isRequired,
      showInterests
    } = this.props;
    const hasError =
      !isPristine() && (showError() || (isRequired() && !hasValue()));

    const cssClasses = ["intl-tel-input", "form-control"];

    return (
      <FormGroup className={className}>
        {title && (
          <Label className={isRequired() && "required"} htmlFor={name}>
            {title}
          </Label>
        )}

        <section className={`${hasError ? "error-border" : ""}`}>
          <IntlTelInput
            name={name}
            disabled={showInterests ? true : false}
            value={getValue() || ""}
            preferredCountries={["ng", "ug", "ke", "gm"]}
            geoIpLookup={this.lookup}
            css={cssClasses}
            style={{ width: "100%" }}
            onPhoneNumberChange={this.changeValue}
            id={name}
          />
        </section>

        {infoText ? <FormText>{infoText}</FormText> : ""}
        {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
        {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
        {showLoader ? <Spinner /> : ""}
      </FormGroup>
    );
  }
}

PhoneInputComponent.propTypes = {
  ...propTypes
};

const MyInput = withFormsy(PhoneInputComponent);

export { MyInput as PhoneInput };
